export const environment = {
  production: false,
  pre: false,
  qa: true,

  allowedParentOriginOTP: 'http://localhost:4200/;https://qa.ri.dentsutracking.com/',
  companyContactEmail: 'support@example.com',

  apiClient: 'https://clients.qa.ri.dentsutracking.com/qa',
  mfaClient: 'https://auth.qa.ri.dentsutracking.com/qa',

  awsMapApiKey: 'v1.public.eyJqdGkiOiI3MGRjYTBiNy1jMjc2LTQwYTMtYWRkNS02ZmU0ZWQ0NTVhYzMifWx2Vod9lpZU2TwDyZboLscVaGr8F5Tkd3Jro6KNLlFOawSU6yWnLFrdS72CTcvEPgRVdQKF___y99PLZW7uiWXTBHyZ5eU9v41_-wrHlNz_AzbmN1WTkf-b5Q7xL42vryrp0cjUgK7mkCQK8PgbIMyDr_mndoVE75SX4xINyiPIvh6JWgRDX1XHiliYItYwzsAG08Z_I3kCqXXxbY9NwgpBiIquDn4wVUwiymXjzOW1Mc-GFTS7JyjJnXp8_sTjRZ6U_6uebJayibOtBsxFsxH-RkhjdAHTH7qM8RKcqJJpqEl9xNi_4nu73RNF7LLbjh6fSAOyjHhqjBw6-0JP-c0.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
  awsRegion: 'eu-west-1',

  dynamsoft: {
    productKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAwNTAzMjkzLXIxNzM5Mjg3NDYwIiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAwNTAzMjkzIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6NjU1OTIyODg3fQ=='
  }
};
